import type { OAuthProvider } from '@/lib/api/auth';

export const PROVIDER_NAMES: Record<OAuthProvider, string> = {
    google: 'Google',
    discord: 'Discord',
    x: 'X',
    telegram: 'Telegram',
};
